import { CSSProperties } from "react";

export const XCardIconSvg = ({
  width,
  style,
}: {
  width: number;
  style?: CSSProperties;
}) => {
  return (
    <svg
      style={style}
      width={width}
      height={(width / 16) * 23}
      viewBox="0 0 16 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_di_219_405)">
        <rect
          x="1"
          y="1"
          width="14"
          height="21"
          rx="1"
          fill="url(#paint0_linear_219_405)"
        />
        <rect
          x="1.5"
          y="1.5"
          width="13"
          height="20"
          rx="0.5"
          stroke="white"
          strokeOpacity="0.92"
        />
      </g>
      <defs>
        <filter
          id="filter0_di_219_405"
          x="0"
          y="0"
          width="16"
          height="23"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_219_405"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_219_405"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect2_innerShadow_219_405"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.67 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_219_405"
          />
        </filter>
        <linearGradient
          id="paint0_linear_219_405"
          x1="8"
          y1="1"
          x2="8"
          y2="22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#197C01" />
          <stop offset="0.489583" stopColor="#235F1A" />
          <stop offset="1" stopColor="#197C01" />
        </linearGradient>
      </defs>
    </svg>
  );
};
